import VpnKeyIcon from '@material-ui/icons/VpnKey';
import AzureAuthenticationCreate from './AzureAuthenticationCreate';
import AzureAuthenticationEdit from './AzureAuthenticationEdit';
import AzureAuthenticationList from './AzureAuthenticationList';
import AzureAuthenticationShow from './AzureAuthenticationShow';

const pages = {
    list: AzureAuthenticationList,
    create: AzureAuthenticationCreate,
    edit: AzureAuthenticationEdit,
    show: AzureAuthenticationShow,
    icon: VpnKeyIcon,
};

export default pages;